import React from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardProps,
  HStack,
  Heading,
} from "@chakra-ui/react";

import { AuxiliaryComponent } from "@constants";
import { AddCommentModal, AddImageModal, CardDivider } from "@components";
import { DocumentActions } from "@hooks";
import { ComponentInfo } from "./ComponentInfo";
import { ScrapAuxiliaryComponentModal } from "./ScrapAuxiliaryComponentModal";
import { SetExpirationDateModal } from "./SetExpirationDateModal";

interface AuxiliaryComponentDetailsProps extends CardProps {
  auxiliaryComponent: AuxiliaryComponent;
  updateComponent: DocumentActions["update"];
}

export function AuxiliaryComponentDetails({
  auxiliaryComponent,
  updateComponent,
  ...delegated
}: AuxiliaryComponentDetailsProps) {
  return (
    <Card {...delegated}>
      <CardHeader>
        <Heading as="h2">{auxiliaryComponent.id}</Heading>
      </CardHeader>
      <CardDivider />
      <CardBody>
        <ComponentInfo auxiliaryComponent={auxiliaryComponent} />
      </CardBody>
      <CardDivider />
      <CardFooter>
        <HStack>
          <AddImageModal itemId={auxiliaryComponent.id} />
          <AddCommentModal itemId={auxiliaryComponent.id} />
          <ScrapAuxiliaryComponentModal updateComponent={updateComponent} />
          <SetExpirationDateModal updateComponent={updateComponent} />
        </HStack>
      </CardFooter>
    </Card>
  );
}
